import dayjs from "dayjs";
import { getLocale } from "./locale";
const format_12h = /^(1[012]|0?[1-9]):?([0-5]?\d)?\s?(am|pm|a|p)?$/i;
const format_24h = /^(2[0-4]|1\d|0?\d):?([0-5]?\d)?$/;
export function now() {
  const now2 = new Date();
  now2.setSeconds(0);
  now2.setMilliseconds(0);
  return now2;
}
export function to_date(date_string, related_date = null) {
  if (date_string == null) {
    return null;
  }
  date_string = (date_string || "").trim();
  if (date_string === ".") {
    return now();
  }
  date_string = insert_colon(date_string);
  const match = date_string.match(format_24h) || date_string.match(format_12h);
  if (!match) {
    return null;
  }
  let hours = match[1];
  if (hours === "24") {
    hours = "00";
  }
  const minutes = match[2] || "00";
  let meridian = getLocale().wants_24h_time || parseInt(hours, 10) > 12 ? match[3] || "" : match[3] || meridian_from(hours, related_date);
  meridian = meridian.toUpperCase();
  if (meridian === "A" || meridian === "P") {
    meridian += "M";
  }
  return new Date(`${dayjs().format("MMMM DD, YYYY")} ${hours}:${minutes}:00 ${meridian}`);
}
export function meridian_from(hour, related_date) {
  const hour_has_leading_zero = hour.trim()[0] === "0";
  hour = parseInt(hour, 10);
  if (related_date != null) {
    if (hour === 0) {
      hour = 12;
    }
    const related_meridian = dayjs(related_date).format("A");
    const related_hour = parseInt(dayjs(related_date).format("hh"), 10);
    hour = hour === 12 && related_hour !== 12 ? 0 : hour;
    switch (false) {
      case !(hour >= related_hour):
        return related_meridian;
      case related_hour !== 12:
        return related_meridian;
      default:
        return inverse_meridian(related_meridian);
    }
  } else {
    const current_24_hour = new Date().getHours();
    const current_meridian = current_24_hour > 11 ? "PM" : "AM";
    const current_hour = current_24_hour % 12;
    if (hour_has_leading_zero && 0 <= hour && hour <= 9) {
      return "AM";
    } else if (hour > 12) {
      return "PM";
    } else if (hour % 12 > current_hour + 1 || hour === 12 && current_hour === 11) {
      return inverse_meridian(current_meridian);
    } else {
      return current_meridian;
    }
  }
}
export function inverse_meridian(meridian) {
  if (meridian.match(/a/i)) {
    return "PM";
  } else {
    return "AM";
  }
}
export function to_string(date = new Date()) {
  const format = getLocale().wants_24h_time ? "H:mm" : "h:mma";
  return dayjs(date).format(format);
}
export function normalize(date_string, related_date_string) {
  const date_ = to_date(date_string, to_date(related_date_string));
  return to_string(date_);
}
export function insert_colon(date_string) {
  date_string = date_string.replace(/\.|,/, ":");
  if (date_string.indexOf(":") !== -1) {
    return date_string;
  }
  const match = date_string.match(/(\d+)(am|pm|a|p)?/i);
  if (!match) {
    return "";
  }
  let numeric = match[1] || "";
  if (numeric.length < 3) {
    numeric = numeric + "00";
  }
  const meridian = match[2] || "";
  const colon_position = numeric.length - 2;
  return numeric.slice(0, colon_position) + ":" + numeric.slice(colon_position, numeric.length) + meridian;
}
